import { GoAFormItem } from '@abgov/react-components';
import moment from 'moment';
import { FC } from 'react';
import { IFlightReport } from '../../../../model/IFlightReport';
import NoteDetails from '../../../notes/CharterNotes';
import styles from './HiringDetails.module.scss';
const { dataContainer } = styles;
interface IHiringDetailsProps {
  flightReport: IFlightReport;
}

const HiringDetails: FC<IHiringDetailsProps> = ({ flightReport, ...props }) => {
  return (
    <>
      <div className={dataContainer}>
        <div>
          <GoAFormItem label='Vendor'>
            <label>{flightReport?.contractRegistration?.name1}</label>
          </GoAFormItem>
        </div>
        <div>
          <GoAFormItem label='Vendor ID'>
            <label>{flightReport?.contractRegistration?.financeVendorId}</label>
          </GoAFormItem>
        </div>

        <div>
          <GoAFormItem label='Hiring Start Date'>
            <label>{flightReport?.contractRegistration ? moment(flightReport?.contractRegistration?.effectiveDate).format('yyyy-MM-DD') : ''}</label>
          </GoAFormItem>
        </div>
        <div>
          <GoAFormItem label='Hiring End Date'>
            <label>
              {flightReport?.contractRegistration ? moment(flightReport?.contractRegistration?.terminationDate).format('yyyy-MM-DD') : ''}
            </label>
          </GoAFormItem>
        </div>

        <div>
          <GoAFormItem label='Point Of Hire'>
            <label>{flightReport?.contractRegistration?.pointOfHire}</label>
          </GoAFormItem>
        </div>
        <div>
          <GoAFormItem label='Contract Number'>
            <label>{flightReport?.contractRegistration?.contractNumber}</label>
          </GoAFormItem>
        </div>

        <div>
          <GoAFormItem label='Contract Type'>
            <label>{flightReport?.contractRegistration?.contractType}</label>
          </GoAFormItem>
        </div>
        <div>
          <GoAFormItem label='Aircraft Type & Size'>
            <label>
              {flightReport?.contractRegistration
                ? flightReport?.contractRegistration?.aircraftType + ' ' + flightReport?.contractRegistration?.aircraftSize
                : ''}
            </label>
          </GoAFormItem>
        </div>
      </div>
      <div>
        <GoAFormItem label='Hiring Remarks' mt='l'>
          <label>{flightReport?.contractRegistration?.remark}</label>
          {<NoteDetails hiringDetailsId={flightReport?.hiringDetailsId} NotesDetailsList={flightReport?.charternotelist}></NoteDetails>}
        </GoAFormItem>
      </div>
    </>
  );
};

export default HiringDetails;
